import script from "./lottory.vue?vue&type=script&setup=true&lang=js"
export * from "./lottory.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__